<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <h1 class="sci-page-title-only">Relatório de Motoristas</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gere a listagem executiva completa de motoristas cadastrados para impressão</p>
      </div>

      <!-- CONFIGURAÇÕES DO RELATÓRIO -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-card-account-details-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  PARÂMETROS DO RELATÓRIO
              </h2>
          </div>
          <div class="p-8">
              <v-row dense>
                <v-col cols="12">
                   <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Prefeitura / Cliente</label>
                  <v-autocomplete
                    :items="prefecturesList"
                    v-model="filter.prefecture_id"
                    item-value="prefecture_id"
                    item-text="prefecture_social_name"
                    placeholder="Selecione uma prefeitura ou Todas as Prefeituras..."
                    outlined dense hide-details="auto"
                    class="bg-slate-50 font-medium"
                    clearable
                    :readonly="!isAdmin"
                  />
                </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button 
                    @click="navigateToDriverReport"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 flex items-center justify-center gap-2 w-fit whitespace-nowrap px-8 h-10 transition-all transform hover:-translate-y-0.5 text-[11px] font-bold uppercase tracking-widest"
                  >
                      <v-icon color="white" small>mdi-printer</v-icon>
                      GERAR RELATÓRIO PARA IMPRESSÃO
                  </button>
              </div>
          </div>
      </section>
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";

export default {
  name: "MotoristasReportFilter",
  mixins: [Helpers],
  data() {
    return {
      loader: false,
      prefectures: [],
      filter: {
        prefecture_id: "all",
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.getUserData.group_id === 1;
    },
    prefecturesList() {
      if (this.isAdmin) {
        return [
          { prefecture_id: "all", prefecture_social_name: "TODAS AS PREFEITURAS" },
          ...this.prefectures,
        ];
      }
      return this.prefectures;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get("/prefectures")
        .then((r) => {
          this.prefectures = r.data || [];
          this.loader = false;
          this.$store.dispatch("setLoader", false);

          if (
            this.$store.getters.getUserData.table_key === "prefectures" &&
            this.$store.getters.getUserData.table_id
          ) {
            this.filter.prefecture_id = this.$store.getters.getUserData.table_id;
          } else if (this.$store.getters.getUserData.group_id !== 1) {
            this.filter.prefecture_id = this.$store.getters.getUserData.table_id;
          }
        })
        .catch(() => {
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    navigateToDriverReport() {
      const prefId = this.filter.prefecture_id || "all";
      const url = `${window.origin}/#/report/motoristas/${prefId}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
</style>
